import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CONTACT } from "@/data/services";

/** Dunkle Kontakt-Sektion (Abschluss jeder Seite) */
export default function CTASection() {
  return (
    <section className="py-16 bg-[#122B18] text-white" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 space-y-5">
            <span className="text-xs font-bold text-[#A3D9A5] uppercase tracking-wider">
              Direktkontakt ohne Umwege
            </span>
            <h2 className="text-3xl sm:text-4xl font-black tracking-tight font-display">Rufen Sie uns direkt an.</h2>
            <p className="text-[#D7E5D9] text-base max-w-xl">
              Wir besprechen Ihr Vorhaben am Telefon und nennen Ihnen sofort den Festpreisrahmen – oder wir vereinbaren
              kurzfristig einen Termin vor Ort.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 pt-1">
              <a
                href={CONTACT.phoneHref}
                data-testid="cta-call-button"
                className="inline-flex justify-center items-center gap-2 bg-[#3D8B4D] hover:bg-[#4AA05C] text-white font-bold px-7 py-4 rounded-lg transition-colors shadow-md"
              >
                <Phone className="w-5 h-5" /> Jetzt anrufen: {CONTACT.phoneDisplay}
              </a>
              <a
                href={CONTACT.emailHref}
                data-testid="cta-mail-button"
                className="inline-flex justify-center items-center gap-2 bg-white/10 hover:bg-white/20 border border-[#3D8B4D] text-white font-bold px-6 py-4 rounded-lg transition-colors"
              >
                <Mail className="w-5 h-5" /> {CONTACT.email}
              </a>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="p-6 rounded-2xl bg-[#1E5631] border border-[#3D8B4D] space-y-4">
              <div>
                <div className="text-xs text-[#A3D9A5] font-bold uppercase flex items-center gap-1.5">
                  <Phone className="w-3.5 h-3.5" /> Telefon (Mobil)
                </div>
                <div className="text-2xl sm:text-3xl font-black text-white font-display" data-testid="cta-phone-display">
                  {CONTACT.phoneDisplay}
                </div>
                <div className="text-xs text-[#D7E5D9] flex items-center gap-1.5 mt-1">
                  <Clock className="w-3.5 h-3.5" /> Erreichbar: {CONTACT.hours}
                </div>
              </div>
              <div className="pt-3 border-t border-[#3D8B4D]/60">
                <div className="text-xs text-[#A3D9A5] font-bold uppercase flex items-center gap-1.5">
                  <Mail className="w-3.5 h-3.5" /> E-Mail
                </div>
                <div className="text-lg font-bold text-white" data-testid="cta-email-display">
                  {CONTACT.email}
                </div>
              </div>
              <div className="pt-3 border-t border-[#3D8B4D]/60">
                <div className="text-xs text-[#A3D9A5] font-bold uppercase flex items-center gap-1.5">
                  <MapPin className="w-3.5 h-3.5" /> Standort
                </div>
                <div className="text-sm font-medium text-white" data-testid="cta-address-display">
                  {CONTACT.street}, {CONTACT.city}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
